import { render, staticRenderFns } from "./AILoading.vue?vue&type=template&id=2dfbb457&scoped=true&"
import script from "./AILoading.vue?vue&type=script&lang=ts&"
export * from "./AILoading.vue?vue&type=script&lang=ts&"
import style0 from "./AILoading.vue?vue&type=style&index=0&id=2dfbb457&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbb457",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCardTitle,VOverlay})
